import { CombinationFormFields } from '@/components/question/forms/combination/CombinationForm';
import {
  positionalColumnGenerator,
  positionalItemGenerator,
  positionalQuestionGenerator,
} from '@/data/generators/positionalQuestionGenerator';
import { AnswerCreateDTO, PositionalItem } from '@/models/Answer';
import { DnDColumnType, DNDPositionalQuestion } from '@/models/Question';
import {
  MediaUrlResolver,
  resolveStringMedia,
} from '@/utils/questions/adapterQuizForm';
import { normalizeTranslatableField } from '@/utils/translatable-field/normalizeTranslatableField';

export default function adapterCombinationForm(
  combination: CombinationFormFields,
  resolveMediaUrl: MediaUrlResolver = resolveStringMedia,
): DNDPositionalQuestion {
  const cues = adapterPositionalItems(
    combination.questions ?? [],
    resolveMediaUrl,
    1,
  );
  const answers = adapterPositionalItems(
    combination.answers ?? [],
    resolveMediaUrl,
    2,
  );

  return positionalQuestionGenerator({
    title: normalizeTranslatableField(combination.title),
    context: normalizeTranslatableField(combination.context),
    questionColumn: positionalColumnGenerator({
      id: 1,
      type: DnDColumnType.QUESTION,
      items: cues,
    }),
    answerColumn: positionalColumnGenerator({
      id: 2,
      name: 'Respostas',
      type: DnDColumnType.ANSWER,
      items: answers,
    }),
  });
}

const adapterPositionalItems = (
  items: (AnswerCreateDTO & { validPositions?: number[] })[],
  resolveMediaUrl: MediaUrlResolver,
  column: number,
): PositionalItem[] =>
  items.map(({ mediaFile, ...item }, index) =>
    positionalItemGenerator({
      ...item,
      id: item.id ?? index,
      order: index + 1,
      dndPositionalColumn: column,
      mediaFile: null,
      mediaLink: resolveMediaUrl(mediaFile) ?? item.mediaLink,
    }),
  );
